/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type DuplicateTemplateMenuItem_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string, owningSystemOrganisationId: string, usedInOtherTemplates: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number } | null } | null };

export const DuplicateTemplateMenuItem_QuoteTemplateFragmentDoc = gql`
    fragment DuplicateTemplateMenuItem_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  title
  owningSystemOrganisationId
  usedInOtherTemplates
  templateSharing {
    id
    subscribedToTemplate {
      subscribedVersionNumber
    }
  }
}
    `;